"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PercentFormatter;

function PercentFormatter(_ref) {
  var _column$options;

  var row = _ref.row,
      column = _ref.column;
  var value = row[column.key];
  var precision = (_column$options = column.options) === null || _column$options === void 0 ? void 0 : _column$options.precision;
  var total = value > 1 ? Number(value) : Number(value) * 100;
  return value ? "".concat(total.toFixed(precision), "%") : null;
}